<template>
    <div>
        <page-header >
            <template #breadcrumbs>
                <router-link to="/analytics">Аналитика</router-link> &raquo; Группа риска
            </template>
            <h2>Группа риска</h2>
        </page-header>

        <section class="content">
            <template v-if="page.table1 || page.table2">
              <div class="d-flex align-items-center">
                <ReportPollFilters @download="doExport" v-bind:filters="filters" v-on:apply="onFiltersApply($event)" v-on:reset="onFiltersReset($event)"/>
              </div>

                <h4 class="mb-4">Статусы</h4>
                <div class="table-inner mb-4" v-if="page.table1">
                    <table class="table-custom">
                        <thead>
                            <tr>
                              <th width="20%"><i style="cursor: pointer" @click="columnSort('name', 'table1')"  class="ml-2 fas text-gray fa-sort-amount-down-alt" :class="{'fas text-black fa-sort-amount-up': tableIn === 1 && sortMode && 'name' === idx, 'text-black': 'name' === idx}"></i></th>
                                <th width="20%" v-if="filters.resultType == 0 || filters.resultType == -1">Высокий риск
                                  <i style="cursor: pointer" @click="columnSort('high', 'table1')"  class="ml-2 fas text-gray fa-sort-amount-down-alt" :class="{'fas text-black fa-sort-amount-up': tableIn === 1 && sortMode && 'high' === idx,'text-black': 'high' === idx}"></i>
                                </th>
                                <th width="20%" v-if="filters.resultType == 1 || filters.resultType == -1">Средний риск
                                  <i style="cursor: pointer" @click="columnSort('medium', 'table1')"  class="ml-2 fas text-gray fa-sort-amount-down-alt" :class="{'fas text-black fa-sort-amount-up': tableIn === 1 && sortMode && 'medium' === idx,'text-black': 'medium' === idx}"></i>
                                </th>
                                <th width="20%" v-if="filters.resultType == 2 || filters.resultType == -1">Низкий риск
                                  <i style="cursor: pointer" @click="columnSort('low', 'table1')"  class="ml-2 fas text-gray fa-sort-amount-down-alt" :class="{'fas text-black fa-sort-amount-up': tableIn === 1 && sortMode && 'low' === idx,'text-black': 'low' === idx}"></i>
                                </th>
                                <th width="20%" v-if="filters.resultType == -1">Итого
                                  <i style="cursor: pointer" @click="columnSort('total', 'table1')"  class="ml-2 fas text-gray fa-sort-amount-down-alt" :class="{'fas text-black fa-sort-amount-up': tableIn === 1 && sortMode && 'total' === idx, 'text-black': 'total' === idx}"></i></th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in page.table1" :key="item.name">
                                <td width="20%">{{ item.name }}</td>
                                <td width="20%" v-if="filters.resultType == 0 || filters.resultType == -1">{{ item.high }}</td>
                                <td width="20%" v-if="filters.resultType == 1 || filters.resultType == -1">{{ item.medium }}</td>
                                <td width="20%" v-if="filters.resultType == 2 || filters.resultType == -1">{{ item.low }}</td>
                                <td width="20%" v-if="filters.resultType == -1">{{ item.total }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h4>Заполнение персональных данных</h4>
                <div class="table-inner mb-4" v-if="page.table2">
                    <table class="table-custom">
                        <thead>
                            <tr>
                                <th><i style="cursor: pointer" @click="columnSort('name', 'table2')"  class="ml-2 fas text-gray fa-sort-amount-down-alt" :class="{'fas text-black fa-sort-amount-up': tableIn === 2 && sortMode && 'name' === idx, 'text-black': 'name' === idx}"></i></th>

                                <th width="20%"  v-if="filters.resultType == 0 || filters.resultType == -1">Высокий риск
                                  <i style="cursor: pointer" @click="columnSort('high', 'table2')"  class="ml-2 fas text-gray fa-sort-amount-down-alt" :class="{'fas text-black fa-sort-amount-up': tableIn === 2 && sortMode && 'high' === idx, 'text-black': 'high' === idx}"></i></th>


                                <th width="20%" v-if="filters.resultType == 1 || filters.resultType == -1">Средний риск
                                  <i style="cursor: pointer" @click="columnSort('medium', 'table2')"  class="ml-2 fas text-gray fa-sort-amount-down-alt" :class="{'fas text-black fa-sort-amount-up': tableIn === 2 && sortMode && 'medium' === idx, 'text-black': 'medium' === idx}"></i></th>


                                <th width="20%" v-if="filters.resultType == 2 || filters.resultType == -1">Низкий риск
                                  <i style="cursor: pointer" @click="columnSort('low', 'table2')"  class="ml-2 fas text-gray fa-sort-amount-down-alt" :class="{'fas text-black fa-sort-amount-up': tableIn === 2 && sortMode && 'low' === idx, 'text-black': 'low' === idx}"></i></th>

                                <th width="20%" v-if="filters.resultType == -1">Итого
                                  <i style="cursor: pointer" @click="columnSort('total', 'table2')"  class="ml-2 fas text-gray fa-sort-amount-down-alt" :class="{'fas text-black fa-sort-amount-up': tableIn === 2 && sortMode && 'total' === idx, 'text-black': 'total' === idx}"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in page.table2" :key="item.name">
                                <td width="20%">{{ item.name }}</td>
                                <td width="20%" v-if="filters.resultType == 0 || filters.resultType == -1">{{ item.high }}</td>
                                <td width="20%" v-if="filters.resultType == 1 || filters.resultType == -1">{{ item.medium }}</td>
                                <td width="20%" v-if="filters.resultType == 2 || filters.resultType == -1">{{ item.low }}</td>
                                <td width="20%" v-if="filters.resultType == -1">{{ item.total }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>



            </template>
            <template v-else>
                <EmptyListMessage/>
            </template>
        </section>
    </div>
</template>
<script>
import API from '../api/poll'
import ReportPollFilters from '../components/ReportPollFilters.vue'

import PageHeader from "@/common/components/page/PageHeader";

//import Constants from "@/common/constants";
import EmptyListMessage from "@/common/components/EmptyListMessage";

export default {
    name: "ApplicantList",
    components: {
        PageHeader,
        ReportPollFilters,
        EmptyListMessage
    },
    data() {
        return {
            filters: {
                dateFrom: '',
                dateTo: '',
                resultType: -1,
                status: -1,
                fill: -1
            },
            page: {},
            modals: {
                filter: false
            },
          sortMode: false,
          idx: null,
          idxCache: null,
          tableIn: null,
        }
    },
    created() {
        this.loadPage();
    },
    methods: {
        loadPage() {
            var self = this;
            var params = Object.assign(this.filters, this.request);
            API.search(params).then(function (response) {
                self.page = response.data;

            });
        },
        onFiltersApply(filters) {
            this.filters = filters;
            this.modals.filter = false;
            this.loadPage();
        },
        onFiltersReset(filters) {
            this.filters = filters || {};
            this.modals.filter = false;
            this.loadPage();
        },
        doExport() {
            //alert("скачиваем эксель");
            API.exportFile(this.filters)
        },
      columnSort(params, table) {
          if(table === "table1") {
            this.tableIn = 1
          } else if(table === "table2") {
            this.tableIn = 2
          }
        this.idx = params
        if(this.idxCache !== this.idx) {
          this.sortMode = false
        }
        this.idxCache = this.idx
        let sortM = this.sortMode
        function Sort(x, y){
          console.log(x)
          if (x[params] < y[params]) {
            return sortM === true ? -1 : 1;
          }
          if (x[params] > y[params]) {
            return sortM === true ? 1 : -1;
          }
          return 0;
        }
        this.page[table].sort(Sort);
        this.sortMode = !this.sortMode
      }
    },
}
</script>
<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.content{
  padding: 32px ;
  position: relative;
  overflow-y: visible;
  .filter{
    position: absolute;
    width: 350px;
    height: auto;
    top: 0;
    right: 0;
    overflow: hidden;
    background-color: transparent;
    opacity: 1;
    transition: opacity .2s;
  }
  .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
</style>